import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import ReactRouterPropTypes from 'react-router-prop-types';
import ReactTable from 'react-table';
import matchSorter from 'match-sorter';

import { Input } from 'components/ui';
import 'material-icons-font/material-icons-font.css';
// import { Loading } from 'components/blocks';
import TablePagination from 'components/ui/TablePagination';
import { showErrorNotification } from 'services/common';
import makeData from './makeData';
import './style.css';

class TemplatePerf extends PureComponent {
  constructor(props) {
    super(props);
    this.reactTable = null;

    this.state = {
      data: [],
      filtered: [],
      filterAll: '',
    };
  }

  async componentDidMount() {
    // eslint-disable-next-line react/prop-types
    const { startDate, endDate } = this.props;
    const { templateId } = this.props.match.params;
    const flags = global.location && queryString.parse(global.location.search);
    const seeded = flags.mode && flags.mode === 'seed';

    if (!seeded) {
      await this.props.getServiceMetrics(templateId, startDate, endDate);
    } else {
      this.setState({
        data: makeData(),
      });
    }
  }

  componentDidUpdate(prevProps) {
    this.showErrors(prevProps);
  }

  showErrors = prevProps => {
    if (this.props.error && prevProps.error !== this.props.error) {
      showErrorNotification(this.props.error);
    }
  };

  setTableRef = element => {
    this.reactTable = element;
  };

  formatPercentage = (refNumber, val) =>
    refNumber === 0 ? (0).toFixed(1) : ((val * 100) / refNumber).toFixed(1);

  formatField = (refNumber, val) => {
    return typeof val === 'undefined'
      ? '-'
      : `${val || 0} (${this.formatPercentage(refNumber, val)}%)`;
  };

  handleFilteredChange = filtered => {
    if (filtered.length > 1 && this.state.filterAll.length) {
      const filterAll = '';
      this.setState({
        filtered: filtered.filter(item => item.id !== 'all'),
        filterAll,
      });
    } else this.setState({ filtered });
  };

  handleFilterAll = e => {
    const { value } = e.target;
    const filterAll = value;
    const filtered = [{ id: 'all', value: filterAll }];
    this.setState({ filterAll, filtered });
  };

  handleSelectionChange = event => {
    const { visible } = this.state;
    const { id } = event.currentTarget;
    visible[id] = !visible[id];

    this.setState({
      visible,
    });
  };

  render() {
    const flags = global.location && queryString.parse(global.location.search);
    const seeded = flags.mode && flags.mode === 'seed';
    const { serviceMetrics } = this.props;
    const { data } = this.state;

    return (
      <div className="performance-body">
        <div className="performance-panel">
          <div className="performance-search">
            <i className="material-icons md-24 performance-icon">search</i>
            <Input
              placeholder="Filter..."
              style={{ border: '0' }}
              value={this.state.filterAll}
              onChange={this.handleFilterAll}
            />
          </div>
          <ReactTable
            PaginationComponent={TablePagination}
            className="-highlight"
            columns={[
              {
                Header: 'id',
                accessor: 'id',
                show: false,
              },
              {
                Header: 'Email Service',
                id: 'pair',
                accessor: 'pair',
              },
              {
                Header: 'Sent',
                id: 'sent',
                accessor: 'sent',
              },
              {
                Header: 'Delivered',
                id: 'delivered',
                accessor: d => this.formatField(d.sent, d.delivered),
              },
              {
                Header: 'Opened',
                id: 'total_open',
                accessor: d => this.formatField(d.sent, d.total_open),
              },
              {
                Header: 'Open.(uniq.)',
                id: 'unique_open',
                accessor: d => this.formatField(d.sent, d.unique_open),
              },
              {
                Header: 'Reply',
                id: 'reply_count',
                accessor: d => this.formatField(d.sent, d.reply_count),
              },
              {
                Header: 'Clickthrough',
                id: 'clickthrough',
                accessor: d => this.formatField(d.sent, d.clickthrough),
              },
              {
                Header: 'Clickthrough.(uniq.)',
                id: 'unique_click',
                accessor: d => this.formatField(d.sent, d.unique_click),
              },
              {
                Header: 'Unsubscribed',
                id: 'unsubscription_count',
                accessor: d => this.formatField(d.sent, d.unsubscription_count),
              },
              {
                Header: 'Spam',
                id: 'spam_count',
                accessor: d => this.formatField(d.sent, d.spam_count),
              },
              {
                Header: 'Hard bounce',
                id: 'bounce_count',
                accessor: d => this.formatField(d.sent, d.bounce_count),
              },
              /*
              {
                Header: 'Soft bounce',
                id: 'soft_bounce',
                accessor: d => this.formatField(d.sent, d.soft_bounce),
              },
              */
              {
                // "filter all" dummy column
                Header: '',
                id: 'all',
                width: 0,
                resizable: false,
                sortable: false,
                show: false,
                Filter: () => {},
                getProps: () => {},
                filterMethod: (filter, rows) => {
                  // using match-sorter
                  const result = matchSorter(rows, filter.value, {
                    keys: ['pair'],
                    threshold: matchSorter.rankings.WORD_STARTS_WITH,
                  });
                  return result;
                },
                filterAll: true,
              },
            ]}
            data={seeded ? data : serviceMetrics}
            defaultPageSize={10}
            filtered={this.state.filtered}
            firstText={<i className="material-icons">first_page</i>}
            lastText={<i className="material-icons">last_page</i>}
            minRows={0}
            nextText={<i className="material-icons">chevron_right</i>}
            previousText={<i className="material-icons">chevron_left</i>}
            ref={this.setTableRef}
            rowsSelectorText="Rows per page"
            showPageJump={false}
            showPaginationBottom
            onFilteredChange={this.handleFilteredChange}
          />
        </div>
      </div>
    );
  }
}

TemplatePerf.defaultProps = {
  serviceMetrics: [],
};

TemplatePerf.propTypes = {
  error: PropTypes.string.isRequired,
  getServiceMetrics: PropTypes.func.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  serviceMetrics: PropTypes.arrayOf(PropTypes.shape({})),
};

export default withRouter(TemplatePerf);
